module.exports = __webpack_public_path__ + "img/p5-p1-bg.f1812442.jpg";